var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row content-header"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v(" "+_vm._s(this.$route.meta.title ? this.$route.meta.title : 'Título')+" ")]),_c('span',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(this.$route.meta.subtitle ? this.$route.meta.subtitle : 'Subtítulo')+" ")]),_c('hr',{staticClass:"w-100"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }